import React from 'react';
import { Link } from 'react-router-dom';
import { BsClouds } from "react-icons/bs";
import { AiOutlineStock } from "react-icons/ai";
import "../introduction.css";

const projectHighlights = (props) => {

    const currentProjects = props.data.projects.map((prj) => {
        let icon = "Distributed Systems, Cloud Computing Project";
        if (prj.type == "finance" ) {
            icon = "Data Science, Finance Project"
        }
        if (prj.type == "ml") {
            icon = "Data Science, Machine Learning Project"
        }
        return <div className='projects_highlight center flex_column'>
            <div className='prj_title'>
                {prj.name}
            </div>
            <div className='prj_icon'>
                {icon}
            </div>
            <div className='prj_description'>
                {prj.description}
            </div>
        </div>
    })

    return (
        /*<div id='me_projects'>
            <div className='container' style={{display: "flex", flexWrap: "wrap"}}>
                <div className='center' style={{flexWrap: "wrap"}}>
                </div>
            </div>
            <div className='poster'>
                PROJECTS
                <div className='poster_hr'/>
                <div className='poster_subheading'>
                    View the projects I have undertaken showing the practical knowledge of application I possess.
                </div>
            </div>
        </div>*/
        <div id='me_projects'>
            <div className='container' style={{marginLeft: "5vh", marginTop: "5vh"}}>
                <div className='poster'>
                    Projects
                    <div className='poster_hr'/>
                    <div className='poster_subheading'>
                        View the projects I have undertaken showing the practical knowledge of application I possess.
                    </div>
                    <div className='view_more_link'>
                        <Link className='more_link' to='projects'>View My Projects in Detail</Link>
                    </div>
                </div>
            </div>
            <div className='poster_right center flex_column'>
                {currentProjects}
            </div>
        </div>
    )
}

export default projectHighlights;